/**
 * Duenner Fetch-Wrapper fuer die Worker-API.
 *
 * - Haengt den Stack-Auth-Access-Token als Bearer an (nie direkter DB-Zugriff vom Browser).
 * - Im Dev wird der Tenant-Slug als X-Maestro-Tenant-Header mitgeschickt, weil localhost
 *   keine Mandanten-Subdomain hat. In Produktion traegt die Subdomain den Mandanten und
 *   VITE_DEV_TENANT ist NICHT gesetzt.
 *
 * OFFENER PUNKT: exakte Methode zum Auslesen des Tokens (user.getAuthJson()). Siehe README.
 */
import { stackApp } from "../stack";

const API_URL = import.meta.env.VITE_API_URL ?? "";
const DEV_TENANT = import.meta.env.VITE_DEV_TENANT;

async function buildHeaders(extra?: HeadersInit): Promise<Headers> {
  const user = await stackApp.getUser();
  if (!user) throw Object.assign(new Error("Nicht eingeloggt"), { statusCode: 401 });

  // { accessToken, refreshToken } - wir brauchen den accessToken (JWT) fuer den Worker.
  const { accessToken } = await user.getAuthJson();

  const headers = new Headers(extra);
  headers.set("Authorization", `Bearer ${accessToken}`);
  if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (DEV_TENANT) headers.set("X-Maestro-Tenant", DEV_TENANT);
  return headers;
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = await buildHeaders(init.headers);
  return fetch(`${API_URL}${path}`, { ...init, headers });
}

/** Wandelt eine nicht-OK-Response in einen Fehler mit statusCode (fuer Refine authProvider.onError). */
export async function toApiError(res: Response): Promise<Error & { statusCode: number }> {
  let message = res.statusText;
  try {
    const body = (await res.json()) as { message?: string; error?: string };
    message = body.message ?? body.error ?? message;
  } catch {
    /* ignore */
  }
  return Object.assign(new Error(message), { statusCode: res.status });
}
